@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row) {
    <span>{{ getOutCome($.row[dataProperty], $.row)?.name }}</span>
  }
}
